import { Modal } from "antd";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import { LicenseItemForm } from "./LicenseItemForm";

const LicenseItemModal = ({
  open,
  setOpen,
  licenseId,
  editingItem,
  existingItems,
  setEditingItem,
  itemsRefetch,
}) => {
  const handleClose = () => {
    setEditingItem(null);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      footer={null}
      width={580}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <LicenseIcon className="text-[18px] text-black " />
          <span className="text-[14px] font-['Poppins'] text-black  ml-2">
            {editingItem?.ItemNo != null
              ? "Edit license item"
              : "Add license item"}
          </span>
        </div>
      }
    >
      {licenseId ? (
        <LicenseItemForm
          licenseId={licenseId}
          editingItem={editingItem}
          existingItems={existingItems}
          onCancel={handleClose}
          onSaved={itemsRefetch}
        />
      ) : null}
    </Modal>
  );
};

export default LicenseItemModal;
